(function($) {

	if ( document.querySelector('.page-template-tempate-landing-page-august-2017') ||
	document.querySelector('.page-template-template-everyday-landing') ) {
		return;
	}

	const createTestimonialPlayPause = (stage) => {

		const pausePlayButton = document.createElement('button');

		pausePlayButton.setAttribute('class', 'carousel-toggle carousel-pause');
		pausePlayButton.setAttribute('id', 'testimonial-toggle');
		pausePlayButton.setAttribute('name', 'Pause');
		$(stage).append(pausePlayButton);
		pausePlayButton.addEventListener('click', toggleTestimonialCarousel);
	}

	const toggleTestimonialCarousel = (e) => {

		const button = e.target;

		if (button.classList[1] === 'carousel-pause') {
			$(button.parentElement).slick('slickPause')
			button.classList.remove('carousel-pause');
			button.classList.add('carousel-play');
		}
		else {
			$(button.parentElement).slick('slickPlay')
			button.classList.remove('carousel-play');
			button.classList.add('carousel-pause');
		}
	}

	const addArrowFunctionality = (prev, next) => {

		prev.addEventListener('click', function (e) {
			$(prev.parentElement).slick('slickPrev')
		});

		next.addEventListener('click', function (e) {
			$(next.parentElement).slick('slickNext')
		});
	}

	const createCarouselArrows = (stage) => {

		const prevArrow = document.createElement('button');
		const nextArrow = document.createElement('button');

		prevArrow.setAttribute('class', 'slick-prev anim-arrows');
		prevArrow.setAttribute('name', 'Previous Slide');

		nextArrow.setAttribute('class', 'slick-next anim-arrows');
		nextArrow.setAttribute('name', 'Next Slide');

		addArrowFunctionality(prevArrow, nextArrow);

		$(stage).append(prevArrow, nextArrow);
	}

	const getCookie = (name) => {

		const value = '; ' + document.cookie;
		const parts = value.split('; ' + name + '=');

		if ( parts.length == 2 ) {
			return parts.pop().split(';').shift();
		}
	}

	if ( $('#home-testimonial-box').length > 0 ) {

		if ( typeof currObjID === undefined ) {
			const currObjID = '0';
		}

		$.ajax({
			type: 'POST',
			url : ajaxurl,
			data: {
				action   : 'get_testimonials',
				currObjID: currObjID,
				wpml_lang: wpml_lang
			},
			success: function(res) {

				const controlsLocation = document.getElementsByClassName('testimonials_wrapper')[0].children[0].children[0]

				$('.testimonials_wrapper').html(res);
				$('#home-testimonial-box .url').removeClass('hide');

				$('.testimonials_wrapper .slick-slider-stage').slick({
					slidesToShow: 1,
					slidesToScroll: 1,
					initialSlide: 0,
					centerMode: false,
					adaptiveHeight: false,
					draggable: false,
					swipe: false,
					arrows: false,
					autoplay: true,
					autoplaySpeed: 3000,
				});

				createTestimonialPlayPause(controlsLocation);
				createCarouselArrows(controlsLocation);
			},
		});
	}

	if ( $('#room_testimonial').length > 0 || $('.testimonials__block').length > 0 ) {

		const $testimonials = $('.testimonial[data-index]');

		if ( $testimonials.length > 0 ) {

			const indexMax = $testimonials.length - 1;
			const randIndex = Math.round( Math.random() * indexMax ); // random # between 0 and 9

			// Pick random testimonial to show
			const $testimonial = $('.testimonial[data-index="' + randIndex + '"]');

			$testimonial.addClass('show');
		}
	}

	if ( $('#testimonial-list-page').length > 0 ) {

		const ajaxData = {
			action     : 'get_testimonial_page',
			pagedCustom: pagedCustom,
			locationTax: locationTax,
			wpml_lang  : wpml_lang
		}

		if ( getCookie('STYXKEY_lf_market') ) {
			ajaxData.franchise_id = getCookie('STYXKEY_lf_market');
		}

		$.ajax({
			type   : 'GET',
			url    : ajaxurl,
			headers: {
				'Cache-control': 'max-age=86400, public',
				'Pragma'       : 'cache'
			},
			cache  : true,
			data   : ajaxData,
			success: function(res) {
				$('.testimonial-content').html(res);
			},
		});
	}
})(jQuery);
